<div class="modal-content">
    <div class="modal-header">
        <h1>📝 Detalle de reserva</h1>
        <span class="reservation-tag {{ reservationStatus(data.status).class }}">
            {{ reservationStatus(data.status).label }}
        </span>
    </div>
    <div mat-dialog-content class="dialog-content">
        <section class="section">
            <p><mat-icon>calendar_today</mat-icon> <strong>Fecha de Reserva:</strong> {{ data.createdDate |
                date:'fullDate' }}</p>
            <p><mat-icon>person</mat-icon> <strong>Reservado por:</strong> {{ data.bookingPerson?.firstName }} {{
                data.bookingPerson?.lastName }}</p>
            <p><mat-icon>badge</mat-icon> <strong>Documento:</strong> {{
                documentTypeLabel(data.bookingPerson?.documentType) }} {{
                data.bookingPerson?.documentNumber }}</p>
            <p><mat-icon>call</mat-icon> <strong>Teléfono:</strong> {{ data.bookingPerson.areaCode }}-{{
                data.bookingPerson.phoneNumber }}</p>
            <p><mat-icon>login</mat-icon> <strong>Check-in:</strong> {{ data.checkInDate | date:'fullDate' }}</p>
            <p><mat-icon>logout</mat-icon> <strong>Check-out:</strong> {{ data.checkOutDate | date:'fullDate' }}</p>
            <p><mat-icon>group</mat-icon> <strong>Huéspedes:</strong> {{ data.guestCount }}</p>
            <p><mat-icon>nights_stay</mat-icon> <strong>Noche(s):</strong> {{ data.reservationDetails[0].numberOfNights
                }}</p>
            <p><mat-icon>attach_money</mat-icon> <strong>Total:</strong> {{ data.totalPrice | currency:'ARS' }}</p>
            <p>
                <!-- <mat-icon>payments</mat-icon> <strong>Anticipo:</strong> {{ data.advancePayment | currency:'ARS' }}
                <span class="payment-tag {{ paymentStatus(data.paymentStatus).class }}">
                    {{ paymentStatus(data.paymentStatus).label }}
                </span>
            </p>
            <p><mat-icon>credit_card</mat-icon> <strong>Medio de pago:</strong> {{
                paymentMethodLabel(data.paymentMethod) }}</p>
            <p><mat-icon>notes</mat-icon> <strong>Observaciones:</strong> {{ data.observations || '-' }}</p> -->
        </section>

        <section class="section">
            <h3><mat-icon>hotel</mat-icon> Habitaciones reservadas</h3>
            <ul class="room-list">
                <li *ngFor="let d of data.reservationDetails">
                    <strong>N° {{ d.room.number }} - {{ d.room.name }}</strong><br>
                    {{ d.numberOfNights }} noche(s) × {{ d.priceAtBooking | currency:'ARS' }} =
                    <strong>{{ d.numberOfNights * d.priceAtBooking | currency:'ARS' }}</strong>
                </li>
            </ul>
        </section>
    </div>

    <div mat-dialog-actions>
        <button mat-button mat-dialog-close color="primary" class="btn btn-primary close-btn">Cerrar</button>
    </div>
</div>